<template>
  <div>
    <div class="consent-container">
      <div :class="['consent', computedClasses]" v-html="consent.message"></div>
      <span @click="toggleExpand" class="btn-tgl-expand">
        {{ this.isExpanded ? 'see less' : 'see more' }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TransactionConsent',
  data() {
    return {
      isExpanded: false,
    }
  },
  computed: {
    ...mapState('consentMessage', ['consent']),
    computedClasses() {
      return {
        'less-content': !this.isExpanded,
      }
    },
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
  },
}
</script>

<style lang="scss" scoped>
.consent-container {
  border-radius: 8px;
  background: #f5f5f5;
  padding: 1px 20px 10px;
  margin: 0 auto;
}

.consent {
  text-align: left;
  margin-bottom: 20px;
  max-height: 500px;
}

.less-content {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.btn-tgl-expand {
  cursor: pointer;
  color: #299cd0;
}
</style>
